import { FilmServiceService } from 'src/app/core/services/contest and drawing/film-service.service';
import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-drawingmain',
  templateUrl: './drawingmain.component.html',
  styleUrls: ['./drawingmain.component.css']
})
export class DrawingmainComponent implements OnInit {
  userId: any;
  drawings: any=[];
  archievd: any;
  showArchieve: any;
  newArray: any;
  id: any;
  routeId: any;

  constructor(private service: FilmServiceService,private adminApi: AdminService,private router: Router) { }

  ngOnInit(): void {
    this.service.getDrawings().subscribe(res=>{
      console.log('response', res);
      this.drawings = res;
     

    });
    this.service.getDrawings().subscribe(res=>{
      console.log('response', res);
      this.archievd = res;
      this.newArray = this.archievd;
      console.log(this.archievd.isClosed)

      console.log(this.newArray.isClosed)

     if(this.newArray.isClosed =="true"){
      this.showArchieve = this.newArray.isClosed;
     }
     console.log(this.showArchieve)
     console.log(this.newArray.isClosed)


    });
   

    this.adminApi.getUserId().subscribe((res: any) => {
      this.userId = res.user;
    });
   
  }
  getDrawingDetail(DrawId:any){
    this.router.navigate(['/contest/' + DrawId]);

        console.log("yes")
      }  
getPoints(id:any){
  this.service.getPointsHistory().subscribe(res=>{
    console.log(res)
    console.log(res[0])

    console.log(res.totalPoints)

        }) 
}
routeToPage(routeId){
  // this.router.navigate(['contest/drawings/'+ routeId.id]);
  window.location.href = '/contest/drawings/'+ routeId.id;

  console.log(routeId);


}
 getDrawingInfo(id:any,event:any){
  event.preventDefault();
console.log(id)
window.location.href = 'contest/drawings/'+ id;

// this.router.navigate[('contest/drawings/'+ id)];
 }

}
